import { invertCroppedDimension } from './math_util';

import type { NodeAPIData } from 'types/catalog_types';
import type { Dimension, Point } from 'types/common_types';
import type { ImageNodeStyleProp, MaskNodeStyleProp } from 'types/node_types';
import type { PhotoCrop } from 'types/photo_types';

export function buildImageNodeStyles(
  node: NodeAPIData,
  nodeDimension: Dimension,
  nodePoint: Point,
  isDropTarget: boolean
): ImageNodeStyleProp {
  const { width, height } = nodeDimension;
  const { x, y } = nodePoint;
  const rotation = node.rotation || 0;

  let imgWrap = {};
  if (isDropTarget) {
    imgWrap = { outline: '3px dashed #f4d03f' };
  }

  return {
    node: {
      zIndex: 2000 + parseInt(node.sort_order.toString()),
      top: `${y || 0}px`,
      left: `${x || 0}px`,
      height: `${height || 0}px`,
      width: `${width || 0}px`,
      transform: `rotate(${rotation}deg)`,
    },
    cropFrame: {
      height: `${height || 0}px`,
      width: `${width || 0}px`,
    },
    imgWrap,
  };
}

export function buildImageNodeCropStyles(crop: PhotoCrop, nodeDimension: Dimension) {
  const cropW = crop.cropW || 1;
  const cropH = crop.cropH || 1;
  const cropX = crop.cropX || 0;
  const cropY = crop.cropY || 0;

  const width = invertCroppedDimension(nodeDimension.width, cropW);
  const height = invertCroppedDimension(nodeDimension.height, cropH);

  // Crop point is the % off of center the image has been moved
  const x = nodeDimension.width / 2 - cropX * width;
  const y = nodeDimension.height / 2 - cropY * height;

  return {
    height: `${height || 0}px`,
    width: `${width || 0}px`,
    transformOrigin: 'center',
    transform: `translate(${x || 0}px, ${y || 0}px)`,
  };
}

export function buildMaskNodeStyles(
  node: NodeAPIData,
  nodeDimension: Dimension,
  nodePoint: Point,
  rotation: number
): MaskNodeStyleProp {
  const { width, height } = nodeDimension;
  const { x, y } = nodePoint;

  return {
    // Style for entire node
    node: {
      zIndex: 2000 + parseInt(node.sort_order.toString()),
      top: `${y || 0}px`,
      left: `${x || 0}px`,
      height: `${height || 0}px`,
      width: `${width || 0}px`,
      transformOrigin: 'center center',
      transform: `rotate(${rotation}deg)`,
    },
    // Style for mask image
    maskImage: {
      position: 'absolute',
      top: '0px',
      left: '0px',
      height: `${height || 0}px`,
      width: `${width || 0}px`,
    },
  };
}
